import { Route, Routes } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import SingleAssistant from "./components/Assistants/SingleAssistants";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import Contact from "./components/Contacts/Contact";
import CustomFields from "./components/Contacts/CustomFields";
import Conversations from "./components/Conversations/Conversations";
import Dashboard from "./components/Dashboard/Dashboard";
import ConfigureForms from "./components/Forms/ConfigureForms";
import FormsListPage from "./components/Forms/FormsListPage";
import Intent from "./components/Intent/Intent";
import LiveAgentChats from "./components/Live-Agent-Chats";
import NotFoundPage from "./components/Notfound";
import PlaygroundPage from "./components/Playground";
import BillingSuccess from "./components/Settings/Billing/BillingSuccess";
import Tools from "./components/Tools";
import CallWidgetCustomizePage from "./components/Widgets/CallwidgetCustomizePage";
import CustomizeWidget from "./components/Widgets/CustomizeWidget";
import { useContext } from "react";
import { ToastContainer } from "react-toastify";
import AddEditAssistant_new from "./components/Assistants/AddEditAssistant_new";
import AgencyDownTime from "./components/Auth/AgencyDownTime";
import ForgotPassword from "./components/Auth/ForgotPassword";
import Login from "./components/Auth/Login";
import OAuthRedirectLoginToken from "./components/Auth/OAuthRedirectLoginToken";
import RedirectAuthenticated from "./components/Auth/RedirectAuthenticated";
import Register from "./components/Auth/Register";
import ResetPassword from "./components/Auth/ResetPassword";
import VerifyEmail from "./components/Auth/VerifyEmail";
import Campaigns from "./components/Campaigns/Campaigns";
import ConversationFlow from "./components/ConversationFlow";
import ConversationFlowTable from "./components/ConversationFlow/Table";
import { AgencyContext } from "./components/Settings/AgencyProvider/AgencyProvider";
import Index from "./components/Voices";
import WebcallWidgetCustomizationPage from "./components/Widgets/WebcallWidgetCustomizationPage";
import useFavicon from "./utils/Hook/useFavicon";
import Loader from "./utils/Loader/Loader";
import { isValidDomain, loadGAtag, loadGTM } from "./utils/utils";
import Assistants from "./components/Assistants/Assistants";
import DataSources from "./components/DataSources/DataSources";
import Widgets from "./components/Widgets/Widgets";
import ActivityTable from "./components/Activity/ActivityTable";
import ConversationsUtility from "./components/Conversations/ConversationsUtility";
import Layout from "./components/Layout/Layout";
import AgencyWrapper from "./components/Agency/AgencyWrapper";
import GettingStarted from "./components/Agency/GettingStarted";
import Branding from "./components/Agency/Tabs/Branding";
import SubAccount from "./components/Agency/Tabs/SubAccount";
import RebillingPlan from "./components/Agency/Tabs/RebillingPlan";
import DomainPlan from "./components/Agency/Tabs/DomainPlan";
import SettingsWrapper from "./components/Settings/SettingsWrapper";
import LogsWrapper from "./components/Logs/LogsWrapper";
import Prompt from "./components/Library/Tabs/Prompt";

function App() {
  const agency = useContext(AgencyContext);
  const { loading, faviconUrl, myDetails, getMyDetails } = agency;

  const logoUrl = !loading ? faviconUrl : null;

  useFavicon(logoUrl);

  if (myDetails && localStorage.getItem("agency_down_time_count"))
    localStorage.removeItem("agency_down_time_count");

  if (loading) {
    return <Loader />;
  }

  if (!isValidDomain(window.location.origin) && !myDetails) {
    return <AgencyDownTime getMyDetails={getMyDetails} />;
  }

  if (isValidDomain(window.location.origin)) {
    loadGTM();
    loadGAtag();
  }

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <RedirectAuthenticated>
              <Login />
            </RedirectAuthenticated>
          }
        />
        <Route
          path="/login"
          element={
            <RedirectAuthenticated>
              <Login />
            </RedirectAuthenticated>
          }
        />
        <Route
          path="/register"
          element={
            <RedirectAuthenticated>
              <Register />
            </RedirectAuthenticated>
          }
        />
        <Route path="/auth" element={<OAuthRedirectLoginToken />} />
        <Route
          path="/forgot-password"
          element={
            <RedirectAuthenticated>
              <ForgotPassword />
            </RedirectAuthenticated>
          }
        />
        <Route
          path="/reset-password"
          element={
            <RedirectAuthenticated>
              <ResetPassword />
            </RedirectAuthenticated>
          }
        />
        <Route
          path="/verify-email"
          element={
            <RedirectAuthenticated>
              <VerifyEmail />
            </RedirectAuthenticated>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <Dashboard />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />

        <Route path="/forms">
          <Route
            path=":formId"
            element={
              <ProtectedRoute>
                <ConfigureForms />
              </ProtectedRoute>
            }
          />
          <Route
            path="new"
            element={
              <ProtectedRoute>
                <ConfigureForms />
              </ProtectedRoute>
            }
          />
          <Route
            path=""
            element={
              <ProtectedRoute>
                <FormsListPage />
              </ProtectedRoute>
            }
          />
        </Route>

        <Route
          path="/assistants/:uuid"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <SingleAssistant />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/live-agent-chats"
          element={
            <ProtectedRoute>
              <LiveAgentChats />
            </ProtectedRoute>
          }
        />

        <Route
          path="/widgets/:widgetId/chat/customize"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <CustomizeWidget />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/widgets/:widgetId/html_call/customize"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <CallWidgetCustomizePage />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/widgets/:widgetId/web_call/customize"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <WebcallWidgetCustomizationPage />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/billing/success"
          element={
            <ProtectedRoute>
              <BillingSuccess />
            </ProtectedRoute>
          }
        />
        <Route
          path="/logs/:selectedLogType"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <LogsWrapper />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings/:name"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <SettingsWrapper />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/conversation-flow"
          element={
            <ProtectedRoute>
              <ConversationFlowTable />
            </ProtectedRoute>
          }
        />
        <Route
          path="/conversation-flow/:id"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <ConversationFlow />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/playground"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <PlaygroundPage />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/ai-agents/assistants"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <Assistants />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ai-agents/data-sources"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <DataSources />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ai-agents/widgets"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <Widgets />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/intents"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <Intent />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/ai-agents/assistants/new"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <AddEditAssistant_new />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ai-agents/assistants/:assistantId"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <AddEditAssistant_new />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/prompts"
          element={
            <ProtectedRoute>
              <Prompt />
            </ProtectedRoute>
          }
        />

        <Route
          path="/tools"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <Tools />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/voices"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <Index />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/engagements"
          element={
            <ProtectedRoute>
              <ConversationsUtility />
            </ProtectedRoute>
          }
        />
        <Route
          path="/engagements/:name"
          element={
            <ProtectedRoute>
                <ConversationsUtility />
            </ProtectedRoute>
          }
        />
        <Route
          path="/engagements/:name/:conversationId"
          element={
            <ProtectedRoute>
                <Conversations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/captured-forms"
          element={
            <ProtectedRoute>
                <ActivityTable />
            </ProtectedRoute>
          }
        />

        <Route
          path="/campaigns"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <Campaigns />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/contacts"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <Contact />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/contacts/custom-field"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <CustomFields />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/agency/getting-started"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <GettingStarted />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agency/branding"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <Branding />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agency/sub-account"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <SubAccount />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agency/rebilling"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <RebillingPlan />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agency/domain"
          element={
            <ProtectedRoute>
              <AgencyWrapper>
                <DomainPlan />
              </AgencyWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="*"
          element={
            <ProtectedRoute>
              <NotFoundPage />
            </ProtectedRoute>
          }
        />
      </Routes>

      <ToastContainer autoClose={3000} />
    </>
  );
}

export default App;
